import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';

export type OptionListName =
  | 'propertyTypes' | 'neighbourhood' | 'services' | 'levels' | 'style' | 'streetAppeal'
  | 'foundations' | 'flooring' | 'mainWalls' | 'windowFrames' | 'roof' | 'interiorLinings'
  | 'ceilingLinings' | 'frame' | 'yearOptions' | 'accommodationPlus' | 'pcItems' | 'fixturesAndFeatures' | 'internalLayout'
  | 'internalCondition' | 'externalCondition' | 'ancillaryCondition'
  | 'mainCarAccomType' | 'siteDescription' | 'significantImprovements' | 'secondaryImprovements'
  | 'secondaryImprovementsOptions' | 'conditionOptions'
  | 'outdoorAreaOptionsList' | 'overallPresentation'
  | 'waterOptions' | 'drainageOptions' | 'fencingOptions' | 'racesOptions'
  | 'essentialRepairComments' | 'otherBuildingPcItemsOptions'
  | 'otherBuildingTitleOptions' | 'otherBuildingFoundationsOptions' | 'otherBuildingFlooringOptions'
  | 'otherBuildingWallsOptions' | 'otherBuildingRoofOptions';

@Injectable({ providedIn: 'root' })
export class OptionsService {
  private readonly http = inject(HttpClient);
  private readonly cache = new Map<OptionListName, Observable<string[]>>();

  get(name: OptionListName): Observable<string[]> {
    const cached = this.cache.get(name);
    if (cached) return cached;
    const request = this.http.get<unknown>(`/assets/options/${name}.json`).pipe(
      map((value) => this.normalize(value)),
      catchError(() => of([])),
      shareReplay(1),
    );
    this.cache.set(name, request);
    return request;
  }

  private normalize(value: unknown): string[] {
    if (Array.isArray(value)) return value.map((item) => String(item));
    if (value && typeof value === 'object') {
      return Object.values(value as Record<string, unknown>).flatMap((item) =>
        Array.isArray(item) ? item.map(String) : [String(item)],
      );
    }
    return [];
  }
}
